import * as types from './types';

const success = type => `${type}_SUCCESS`;
const error = type => `${type}_ERROR`;

const initialState = {
  adminLocations: {
    isLoading: true,
    isError: false,
    data: []
  },
  adminLocation: {
    isLoading: true,
    isError: false,
    data: null
  },
  updateAdminLocationSettings: {
    isLoading: false,
    isError: false
  },
  createAdminLocation: {
    isLoading: false,
    isError: false
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LIST_ADMIN_LOCATIONS:
      return {
        ...state,
        adminLocations: { isLoading: true, isError: false, data: state.adminLocations.data }
      };
    case success(types.LIST_ADMIN_LOCATIONS):
      return {
        ...state,
        adminLocations: { isLoading: false, isError: false, data: action.payload.data }
      };
    case error(types.LIST_ADMIN_LOCATIONS):
      return {
        ...state,
        adminLocations: { ...state.adminLocations, isLoading: false, isError: true }
      };
    case types.GET_ADMIN_LOCATION:
      return {
        ...state,
        adminLocation: { isLoading: true, isError: false, data: null }
      };
    case success(types.GET_ADMIN_LOCATION):
      return {
        ...state,
        adminLocation: { isLoading: false, isError: false, data: action.payload.data }
      };
    case error(types.GET_ADMIN_LOCATION):
      return {
        ...state,
        adminLocation: { isLoading: false, isError: true, data: null }
      };
    case types.UPDATE_ADMIN_LOCATION_SETTINGS:
      return {
        ...state,
        updateAdminLocationSettings: { isLoading: true, isError: false }
      };
    case success(types.UPDATE_ADMIN_LOCATION_SETTINGS): {
      const location = action.payload.data;
      return {
        ...state,
        adminLocation: { isLoading: false, isError: false, data: location },
        updateAdminLocationSettings: { isLoading: false, isError: false },
        adminLocations: {
          ...state.adminLocations,
          data: state.adminLocations.data.map(item => item.locationId === location.locationId
            ? {
              ...item,
              provider: location.provider,
              allowTestCards: location.allowTestCards,
              squareLocationId: location.squareLocationId,
              adyenMerchantAccount: location.adyenMerchantAccount,
              adyenStoreId: location.adyenStoreId,
              adyenCurrencyCode: location.adyenCurrencyCode
            }
            : item)
        }
      };
    }
    case error(types.UPDATE_ADMIN_LOCATION_SETTINGS):
      return {
        ...state,
        updateAdminLocationSettings: { isLoading: false, isError: true }
      };
    case types.CREATE_ADMIN_LOCATION:
      return {
        ...state,
        createAdminLocation: { isLoading: true, isError: false }
      };
    case success(types.CREATE_ADMIN_LOCATION): {
      const location = action.payload.data;
      const summary = {
        locationId: location.locationId,
        squareLocationId: location.squareLocationId,
        provider: location.provider,
        allowTestCards: location.allowTestCards,
        adyenMerchantAccount: location.adyenMerchantAccount,
        adyenStoreId: location.adyenStoreId,
        adyenCurrencyCode: location.adyenCurrencyCode
      };
      return {
        ...state,
        createAdminLocation: { isLoading: false, isError: false },
        adminLocation: { isLoading: false, isError: false, data: location },
        adminLocations: {
          ...state.adminLocations,
          data: [summary, ...state.adminLocations.data.filter(item => item.locationId !== location.locationId)]
        }
      };
    }
    case error(types.CREATE_ADMIN_LOCATION):
      return {
        ...state,
        createAdminLocation: { isLoading: false, isError: true }
      };
    default:
      return state;
  }
};